<template>
  <div class="singlehour">
    <div class="singlehour0">
      <div class="h">{{(sum.time)}}</div>
      <div :value="'總人數'" :style="{color: 'var(--highlight)'}">{{((sum.reserveNum||0)+(sum.reserveNumChild||0)||0).toFixed(0)}}</div>
      <div :value="'總桌菜'">{{(sum.tabs||0).toFixed(1)}}</div>
      <div :value="'總套餐'">{{(sum.sets||0).toFixed(0)}}</div>
      <div :value="'總組數'">{{(sum.count).toFixed(0)}}</div>
    </div>
    <div class="singlehour1"  v-for="(instore, i) in instores" :key="i">
      <div class="h1"><div>{{(instore.time)}}</div></div>
      <div :value="'人數'" :style="{color: 'var(--highlight)'}">{{(instore.num||0).toFixed(0)}}</div>
      <div :value="'桌菜'">{{(instore.tabs||0).toFixed(1)}}</div>
      <div :value="'套餐'">{{(instore.sets||0).toFixed(0)}}</div>
      <div :value="'組數'">{{(instore.count).toFixed(0)}}</div>
    </div>
  </div>
</template>

<script>
import { postapi } from '../../../store/fetch'
export default {
  props: ['sum', 's', 'd', 'store', 'storeType', 'page'],
  data () {
    return {
      reasons: [
        '預約額滿',
        '特殊節日僅開放電話預約',
        '活動包場'
      ]
    }
  },
  computed: {
    instores () {
      const __times = this.sum.instore.map(e => e.visitTime)
      const times = Array.from(new Set(__times)).sort((a, b) => a.localeCompare(b) ? 1 : -1)
      return times.map(t => {
        const x = this.sum.instore.filter(e => e.visitTime === t)
        return {
          x,
          time: t,
          num: x.map(e => (e.reserveNum || 0) + (e.reserveNumChild || 0)).reduce((a, b) => a + b, 0),
          tabs: x.map(e => e.Orders.map(o => o.unit === '桌' ? o.count : 0).reduce((a, b) => a + b, 0)).reduce((a, b) => a + b, 0),
          sets: x.map(e => e.Orders.map(o => o.unit === '套' ? o.count : 0).reduce((a, b) => a + b, 0)).reduce((a, b) => a + b, 0),
          count: x.length
        }
      })
    }
  },
  methods: {
    async updateStatus (ev) {
      if (this.sum.reason === ev) {
      } else {
        console.log(ev, 'updateStatus')
        const r = await postapi('restaurantStatus/dt', {
          date: this.sum.date,
          time: this.sum.time,
          reason: ev,
          store: this.store
        })
        if (r) {
          this.$emit('update')
        }
      }
    },
    group (h) {
      return this.sum.summary.filter(e => e.visitTime === h).length
    },
    num (h) {
      return this.sum.summary.filter(e => e.visitTime === h).map(e => (e.reserveNum || 0) + (e.reserveNumChild || 0)).reduce((a, b) => a + b, 0)
    },
    table (h) {
      return [].concat(...this.sum.summary.filter(e => e.visitTime === h).map(e => e.Orders)).filter(e => e.unit === '桌').map(e => e.count).reduce((a, b) => a + b, 0)
    },
    set (h) {
      return [].concat(...this.sum.summary.filter(e => e.visitTime === h).map(e => e.Orders)).filter(e => e.unit === '套').map(e => e.count).reduce((a, b) => a + b, 0)
    }
  }

}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.singlehour {
  box-shadow: 0 0 5px rgba(0,0,0,.25);
}
.singlehour1 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  background-color: transparent;
  border-radius: 5px;
  height: 70px;
  .h1 {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    div {
      width: 60px;
      height: 40px;
      border-radius: 3px;
      border: 1px solid var(--color-pri);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--color-pri);
      letter-spacing: .1em;
    }
  }
  &>div:not(.h1) {
    padding: 5px;
    display: grid;
    grid-template-rows: 25px 35px;
    font-weight: 700;
    font-size: 20px;
    align-items: center;
    justify-content: center;
    text-align: center;
    letter-spacing: .1em;
    color: #5e5e5e;
    &::before {
      content: attr(value);
      font-size: 14px;
      text-align: center;
      letter-spacing: .1em;
      color: #959595;
      margin-bottom: 6px;
    }
  }
}
.singlehour0:last-child .h {
  border-bottom-left-radius: 5px;
}
.singlehour0 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  background-color: var(--color-bar);
  border-radius: 5px;
  height: 60px;
  .h {
    background-color: var(--color-pri);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    border-radius: 5px 0 0 0;
    background-color: var(--color-checked);
    color: #fff;
    font-weight: 800;
    font-size: 20px;
    letter-spacing: .1em;
  }
  &>div:not(.h) {
    padding: 3px;
    display: grid;
    grid-template-rows: 22px 32px;
    font-weight: 700;
    font-size: 20px;
    align-items: center;
    justify-content: center;
    text-align: center;
    letter-spacing: .1em;
    color: #5e5e5e;
    &::before {
      content: attr(value);
      font-size: 14px;
      text-align: center;
      letter-spacing: .1em;
      color: #959595;
      margin-bottom: 6px;
    }
  }
}
</style>
